"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_1 = require("../../../../theming/theme");

exports.SaveButton = function (props) {
  return react_1.default.createElement(react_native_1.TouchableOpacity, {
    onPress: props.onPress,
    style: props.isActive ? styles.saveButtonView : styles.saveButtonDisabledView,
    disabled: !props.isActive
  }, react_1.default.createElement(react_native_1.Text, {
    style: styles.saveButtonText
  }, "Save"));
};

var saveButtonView = {
  alignSelf: 'flex-end',
  backgroundColor: theme_1.PurpleScale.darkest,
  padding: 10
};

var saveButtonDisabledView = __assign(__assign({}, saveButtonView), {
  backgroundColor: theme_1.GreyScale.regular
});

var saveButtonText = {
  color: theme_1.GreyScale.lightest,
  fontWeight: theme_1.FontWeight.bold
};
var styles = react_native_1.StyleSheet.create({
  saveButtonDisabledView: saveButtonDisabledView,
  saveButtonText: saveButtonText,
  saveButtonView: saveButtonView
});